(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
    const initCollectionReadMore = (container = document) => {
      container.querySelectorAll('[data-read-more]').forEach(wrapper => {
        if (wrapper.dataset.readMoreInitialised === 'true') return;

        const content = wrapper.querySelector('[data-read-more-content]');
        const toggle = wrapper.querySelector('[data-read-more-toggle]');
        const label = wrapper.querySelector('[data-read-more-label]');

        if (!content || !toggle || !label) return;

        wrapper.dataset.readMoreInitialised = 'true';
        content.classList.add('is-clamped');

        const update = () => {
          if (wrapper.classList.contains('is-expanded')) return;

          content.classList.remove('is-clamped');
          const fullHeight = content.scrollHeight;

          content.classList.add('is-clamped');
          const clampedHeight = content.clientHeight;

          toggle.hidden = fullHeight <= clampedHeight + 1;
        };

        toggle.addEventListener('click', () => {
          const isExpanded = wrapper.classList.toggle('is-expanded');

          content.classList.toggle('is-clamped', !isExpanded);
          toggle.setAttribute('aria-expanded', String(isExpanded));
          label.textContent = isExpanded ? 'Read less' : 'Read more';
        });

        requestAnimationFrame(update);

        window.addEventListener('resize', update);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initCollectionReadMore();
      });
    } else {
      initCollectionReadMore();
    }

    document.addEventListener('shopify:section:load', event => {
      initCollectionReadMore(event.target);
    });
  
  } catch(e) { console.error(e); }
})();
})();
